exports = module.exports = require("../../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-tag[data-v-e304bfc6] {\n  height: auto;\n  text-align: center;\n  font-size: 16px;\n  margin-right: 15px;\n  width: 100px;\n}\n.top-box[data-v-e304bfc6] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.select-box[data-v-e304bfc6] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  margin-top: 10px;\n  margin-right: 20px;\n}", ""]);

// exports
